import request from '@/utils/request'

export const searchTaskByPage = data => {
  return request({
    url: '/approval/searchTaskByPage',
    method: 'POST',
    params: data
  })
}

export const searchNoApprovalTask = data => {
  return request({
    url: '/approval/searchNoApprovalTask',
    method: 'POST',
    params: data
  })
}

export const searchEndingTask = data => {
  return request({
    url: '/approval/searchEndingTask',
    method: 'POST',
    params: data
  })
}

export const searchApprovalTask = data => {
  return request({
    url: '/approval/searchApprovalTask',
    method: 'POST',
    params: data
  })
}

export const searchTaskByMe = data => {
  return request({
    url: '/approval/searchTaskByMe',
    method: 'POST',
    params: data
  })
}

export const searchApprovalContent = data => {
  return request({
    url: '/approval/searchApprovalContent',
    method: 'POST',
    params: data
  })
}

export const approvalTask = data => {
  return request({
    url: '/approval/approvalTask',
    method: 'POST',
    params: data
  })
}

export const approvalExpertTask = data => {
  return request({
    url: '/approval/approvalExpertTask',
    method: 'POST',
    params: data
  })
}

export const archiveFileNumber = data => {
  return request({
    url: '/approval/archiveFileNumber',
    method: 'POST',
    data
  })
}

export const archive = data => {
  return request({
    url: '/approval/archive',
    method: 'POST',
    data
  })
}
